import HomePage from "./Home";
const Home = () => {
  return <HomePage />;
};
export default Home;